var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModuleStatusComplete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#7DDA7D",
    cx: 25,
    cy: 25,
    r: 25
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#21A921",
    cx: 25,
    cy: 25,
    r: 19
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.385 21.583L24.39 32.578a2.1 2.1 0 0 1-2.969 0l-5.808-5.809a2.1 2.1 0 0 1 0-2.966c.82-.82 2.148-.82 2.966 0l4.327 4.325 9.512-9.513a2.098 2.098 0 1 1 2.966 2.968",
    fill: "#FFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModuleStatusComplete);
export default __webpack_public_path__ + "static/media/module-status-complete.d8f90b8dbf6081314b4d061007db55c7.svg";
export { ForwardRef as ReactComponent };